import { ECurrencyType, IJsonQuery } from '@cian/api-models/common/json_query';
import { FDealType, getDealType } from './jsonQuery';

export const currencyTypeMap = {
  [ECurrencyType.Dollar]: '\u0024',
  [ECurrencyType.Rouble]: '\u20BD',
  [ECurrencyType.Euro]: '\u20AC',
};

export function getPriceLocale(jsonQuery: IJsonQuery): string {
  const { currency } = jsonQuery;
  const dealType = getDealType(jsonQuery);
  const currencySign =
    (currency && currency.value && currencyTypeMap[currency.value]) || currencyTypeMap[ECurrencyType.Rouble];

  switch (true) {
    /**
     * не менять положение первого кейса: при переключении фильтров между вертикалями
     * поле price_sm остается, но при этом для аренды жилой недвижимости нужно выводить
     * цену с лейблом "Р/мес."
     */
    case dealType === FDealType.RentLongterm || dealType === FDealType.Rent:
      return `${currencySign}/мес.`;
    case dealType === FDealType.RentDaily:
      return `${currencySign}/сутки`;
    case dealType === FDealType.Sale:
      return currencySign;
    default:
      return currencySign;
  }
}
